module.exports = __webpack_public_path__ + "static/media/icon_edit.d26bbf49.svg";